<script setup>
/* Imports */
import { ref } from 'vue';
import useGlobalStore from '../store/globalStore.js';

/* Helpers */
import {
  getComponentFromList,
} from '../utils/mainUtils.js';

/* Composables */
import { useGetComponents } from '../composables/useGetComponents.js';

/* Initialize Composables */
const { getComponents } = useGetComponents();

/* Store */
const globalStore = useGlobalStore();

/* State */
const state = ref({
  componentList: getComponents(globalStore.getCollection?.content),
});

/* Methods */
const getComponent = (reference) => getComponentFromList(reference, state.value?.componentList);

// Lazy load remaining posts
globalStore.fetchPosts();
</script>

<template>
  <div
    class="app__filterable-archive"
  >
    <component
      :is="{ ...getComponent(reference) }"
      v-for="reference in globalStore.getCollection?.content?.references"
      :key="reference?.id"
      :content="reference"
      :locale="globalStore.locale"
    />
  </div>
</template>
